import { InjectionToken } from '@angular/core';

export const BACKEND_CONFIG = new InjectionToken<ApiContext>('backend.config');
export const PUSHMONKEY_CONFIG = new InjectionToken<ApiContext>('pushmonkey.config');

export interface ApiContext {
  baseUrl: string;
}
